var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTranslate = function SvgIconTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 14.38,
    y1: 72.9,
    x2: 91.05,
    y2: 18.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27.01,
    y1: 90.7,
    x2: 103.69,
    y2: 36.28,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_31_-_40",
    "data-name": " 31 - 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.64,33.43h-25v-14.77c0-6.27-5.09-11.36-11.36-11.36H11.36C5.09,7.3,0,12.38,0,18.65v27.27c0,6.27,5.09,11.36,11.36,11.36v4.75c0,1.83,1.1,3.49,2.8,4.19,1.7.71,3.67.32,4.97-.99.08-.08.16-.17.23-.26l5.65-7.69h11.35v14.77c0,6.27,5.09,11.36,11.36,11.36h25.2l7.95,7.95c1.78,1.77,4.65,1.77,6.43,0,.85-.85,1.33-2.01,1.33-3.21v-4.74c6.27,0,11.36-5.09,11.36-11.36v-27.27c0-6.27-5.09-11.36-11.36-11.36ZM23.86,52.74c-.72,0-1.39.35-1.82.92l-6.14,8.32v-6.97c0-1.26-1.02-2.27-2.27-2.27h-2.27c-3.77,0-6.82-3.05-6.82-6.82v-27.27c0-3.77,3.05-6.82,6.82-6.82h40.91c3.77,0,6.82,3.05,6.82,6.82v14.77h-11.36c-2.42,0-4.77.79-6.71,2.24l-7.13-15.68c-.52-1.14-1.87-1.65-3.01-1.13-.5.23-.9.63-1.13,1.13l-11.36,25c-.52,1.14-.01,2.49,1.13,3.01,0,0,0,0,0,0,.29.14.61.21.93.21.89,0,1.7-.52,2.07-1.33l3.53-7.76h11.54l.16.35c-.9,1.63-1.38,3.47-1.39,5.33v7.95h-12.5ZM35.53,34.56h-7.41l3.7-8.15,3.71,8.15ZM95.45,72.06c0,3.77-3.05,6.82-6.82,6.82h-2.27c-1.26,0-2.27,1.02-2.27,2.27v7.01l-8.62-8.62c-.43-.43-1-.67-1.61-.67h-26.14c-3.77,0-6.82-3.05-6.82-6.82v-27.27c0-3.77,3.05-6.82,6.82-6.82h40.91c3.77,0,6.82,3.05,6.82,6.82v27.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.55,50.47h-9.09v-4.55c0-1.26-1.02-2.27-2.27-2.27s-2.27,1.02-2.27,2.27v4.55h-9.09c-1.26,0-2.27,1.02-2.27,2.27s1.02,2.27,2.27,2.27h16.86c-.56,3.86-2.52,7.38-5.51,9.88-1.75-1.46-3.16-3.28-4.14-5.34-.51-1.15-1.86-1.66-3-1.15-1.15.51-1.66,1.86-1.15,3,.01.03.03.06.05.1,1.06,2.19,2.5,4.17,4.26,5.85-2.02.86-4.19,1.3-6.39,1.3-1.22,0-2.2,1-2.19,2.21,0,.02,0,.04,0,.06.04,1.27,1.08,2.28,2.35,2.27,3.61,0,7.16-.97,10.27-2.8,3.14,1.82,6.71,2.79,10.34,2.8,1.22,0,2.2-1,2.19-2.21,0-.02,0-.04,0-.06-.04-1.27-1.08-2.28-2.35-2.27-2.13,0-4.23-.45-6.18-1.29,3.39-3.29,5.52-7.66,6.05-12.35h1.27c1.26,0,2.27-1.02,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  })))));
};
export default SvgIconTranslate;